import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: 'menu.dashboard', icon: 'el-icon-s-home' } },
      // Content
      { path: 'content/articles', name: 'Articles', component: () => import('@/views/content/articles.vue'), meta: { title: 'menu.articles' } },
      { path: 'content/banners', name: 'Banners', component: () => import('@/views/content/banners.vue'), meta: { title: 'menu.banners' } },
      { path: 'content/company', name: 'Company', component: () => import('@/views/content/company.vue'), meta: { title: 'menu.company' } },
      // Business
      { path: 'business/products', name: 'Products', component: () => import('@/views/products/index.vue'), meta: { title: 'menu.products' } },
      { path: 'business/solutions', name: 'Solutions', component: () => import('@/views/solutions/index.vue'), meta: { title: 'menu.solutions' } },
      { path: 'business/cases', name: 'Cases', component: () => import('@/views/cases/index.vue'), meta: { title: 'menu.cases' } },
      { path: 'business/customers', name: 'Customers', component: () => import('@/views/customers/index.vue'), meta: { title: 'menu.customers' } },
      { path: 'business/map-markers', name: 'MapMarkers', component: () => import('@/views/map-markers/index.vue'), meta: { title: 'menu.mapMarkers' } },
      // Interaction
      { path: 'interaction/messages', name: 'Messages', component: () => import('@/views/messages/index.vue'), meta: { title: 'menu.messages' } },
      { path: 'interaction/downloads', name: 'Downloads', component: () => import('@/views/downloads/index.vue'), meta: { title: 'menu.downloads' } },
      { path: 'interaction/certificates', name: 'Certificates', component: () => import('@/views/certificates/index.vue'), meta: { title: 'menu.certificates' } },
            { path: 'interaction/contacts', name: 'Contacts', component: () => import('@/views/contacts/index.vue'), meta: { title: 'menu.contacts' } },
      // System
      { path: 'system/users', name: 'Users', component: () => import('@/views/system/users.vue'), meta: { title: 'menu.users' } },
      { path: 'system/roles', name: 'Roles', component: () => import('@/views/system/roles.vue'), meta: { title: 'menu.roles' } },
      { path: 'system/menus', name: 'Menus', component: () => import('@/views/system/menus.vue'), meta: { title: 'menu.menus' } },
      { path: 'system/configs', name: 'Configs', component: () => import('@/views/system/configs.vue'), meta: { title: 'menu.configs' } },
      { path: 'system/logs', name: 'Logs', component: () => import('@/views/system/logs.vue'), meta: { title: 'menu.logs' } },
      { path: 'system/dicts', name: 'Dicts', component: () => import('@/views/system/dicts.vue'), meta: { title: 'menu.dicts' } }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach(async (to, from, next) => {
  if (to.meta.public) return next()
  if (!store.state.user.token) return next('/login')
  // Restore user state after page refresh
  if (!store.state.user.userInfo) {
    await store.dispatch('user/fetchUserInfo')
  }
  if (!store.state.user.menus.length) {
    await store.dispatch('user/fetchMenus')
  }
  if (!store.state.siteConfig.siteName) {
    await store.dispatch('fetchSiteConfig')
  }
  // Update page title
  document.title = store.state.siteConfig.siteName || 'Admin'
  next()
})

export default router
